export class OfficeEquipmentBrandResult {
    public id: number = 0;
    public name: string = '';
    public isDeleted: boolean = false;
}
